import { DisputeReviewFragmentType } from '@pay-bill/graphql';
import React from 'react';
import {
  DisputeBodyDetails,
  DisputeDiffLine,
  DisputeDiffSection,
  DisputeFilesSection,
  DisputeReviewDrawerFooter,
  DrawerBody,
  DrawerFooter,
  DrawerTitle,
  InvoiceItemDiffLine,
  SimpleDiffLine,
} from '@pay-bill/components';
import { useCurrentEntity } from '@identity/hooks';
import { buildEstimationMessage, hasDisputeActions } from '@pay-bill/services';
import { HistoryDropDown, Row, Divider } from '@common/components';
export const DisputeReviewDrawerBody = ({
  dispute,
  onClose,
}: {
  dispute: DisputeReviewFragmentType;
  onClose: () => void;
}) => {
  const currentEntity = useCurrentEntity();
  const entityType = currentEntity.entityType;

  const typeLabel = dispute.disputeType === 'error' ? 'Error' : 'Missing Line';
  const showEstimationMessage = dispute.worksInvoice.preCalculated;

  const estimationMessage = buildEstimationMessage(
    entityType,
    dispute.updatedBy?.entityType
  );

  return (
    <>
      <DrawerTitle>Review {typeLabel} Dispute</DrawerTitle>
      <DrawerBody>
        <DisputeBodyDetails dispute={dispute} />

        <DisputeDiffSection mode="view">
          {dispute.disputeType === 'error' && dispute.worksInvoiceItem ? (
            <InvoiceItemDiffLine item={dispute.worksInvoiceItem} />
          ) : (
            <SimpleDiffLine.Empty />
          )}
          <DisputeDiffLine
            current
            dispute={dispute}
            showEstimationSymbol={showEstimationMessage}
          />
          {showEstimationMessage && (
            <p className="estimation-message">{estimationMessage}</p>
          )}
        </DisputeDiffSection>

        <Divider gutter={16} />

        <Row>
          <DisputeFilesSection dispute={dispute} />
        </Row>

        <Divider gutter={16} />

        <HistoryDropDown data={dispute.history} hrVisible={false} />
      </DrawerBody>

      {hasDisputeActions(dispute) && (
        <DrawerFooter>
          <DisputeReviewDrawerFooter dispute={dispute} onClose={onClose} />
        </DrawerFooter>
      )}
    </>
  );
};
